import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { makeStyles } from '@material-ui/core';
import cn from 'classnames';

const useStyles = makeStyles(theme => ({
  li: {
    '&::after': {
      background: theme.palette.primary.main,
    },
  },
}));

const ProgressBar = ({ value }) => {
  const classes = useStyles();
  return (
    <div className={styles.container}>
      <ul className={cn(styles.progressbar)}>
        {value.map((data, key) => {
          return (
            <li
              className={cn(data.active && styles.active, classes.li)}
              key={key}
            >
              {data.value}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

ProgressBar.propTypes = {
  value: PropTypes.array,
};

export default ProgressBar;
